import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
        margin: theme.spacing(1),
    },
  }),
);

interface IProps {
  onClicked: () => void;
  isClicked: boolean;
  clickColor: string;
  noClickColor: string;
  icon: IconProp;
  iconSize: SizeProp;
  iconText: string;
  buttonSize?: string | number;
  textFontSize: string;
};

export const RoomControlButton: React.FC<IProps> = ({onClicked, isClicked, clickColor, noClickColor, icon, iconSize, iconText, buttonSize, textFontSize}) => {
  const classes = useStyles();

  return (
    <Button variant="contained" color="primary" className={classes.button} onClick={onClicked} style={{ backgroundColor: isClicked ? clickColor : noClickColor, width: buttonSize, height: buttonSize}}>
        <div style={{ position: 'absolute', top: 0, left: 0, padding: 8}}>
            <FontAwesomeIcon icon={icon} size={iconSize} />
        </div>        
        <div style={{ position: 'absolute', bottom: 0, left: 0, padding: 8}}>
            <Typography variant="body1" align="left" style={{ fontSize: textFontSize }}>{iconText}</Typography>
        </div>
    </Button>   
  );
};